// services/fontteService/abandoned.ts - services/fontteService.ts split (sub-module abandoned)

import { getApiUrl } from '../apiConfig.js';

import type {AbandonedReminderParams} from './types.js';
import type {FontteResponse} from './types.js';
import { VPS_API_KEY } from './config.js';
import { VPS_API_URL } from './config.js';


export async function sendAbandonedReminder(params: AbandonedReminderParams): Promise<FontteResponse> {
  const VPS_API_URL = getApiUrl();
  const VPS_API_KEY = import.meta.env.VITE_VPS_API_KEY || '';
  if (!VPS_API_URL) return { status: false, message: 'VPS_API_URL not configured', errorCode: 'CONFIG_ERROR' };
  try {
    const response = await fetch(`${VPS_API_URL}/api/whatsapp/send-abandoned-reminder`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'x-api-key': VPS_API_KEY },
      body: JSON.stringify(params), signal: AbortSignal.timeout(15000),
    });
    const text = await response.text();
    let data; try { data = JSON.parse(text); } catch { data = null; }
    if (!response.ok || (data && !data.success)) return { status: false, message: data?.error || text || 'Gagal kirim abandoned reminder', errorCode: 'ABANDONED_ERROR', details: { status: response.status, response: data || text } };
    // bawa full payload (termasuk skipped/reason) — data?.data kadang undefined saat skipped
    return { status: true, message: data?.skipped ? `Dilewati: ${data.reason || 'no_template'}` : 'Abandoned reminder terkirim', data: data?.data ?? data };
  } catch (error: any) { return { status: false, message: error.message || 'Abandoned API connection failed', errorCode: 'ABANDONED_NETWORK_ERROR' }; }
}
